export default __webpack_public_path__ + "static/media/cover2.f5d6927f.jpeg";